import { SVGProps } from "react"
const InformationMissingError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="#D92D20"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.333}
        d="M8.5 5.667V8.5m0 2.833h.007M15.583 8.5a7.083 7.083 0 1 1-14.166 0 7.083 7.083 0 0 1 14.166 0Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h17v17H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default InformationMissingError